var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "round-history-page" },
    [
      _c("ui-game-info", {
        attrs: {
          "game-mode": "wheel",
          "game-id": _vm.gameData ? _vm.gameData.id : undefined,
          playersCount: _vm.gameData ? _vm.gameData.usersCount : undefined,
          playersBetSum: _vm.gameData ? _vm.gameData.totalBankUsd : undefined,
          publicSeed:
            _vm.gameData && _vm.gameData.fairGame
              ? _vm.gameData.fairGame.serverSeedHash
              : undefined,
          privateSeed:
            _vm.gameData && _vm.gameData.fairGame
              ? _vm.gameData.fairGame.serverSeed
              : undefined,
        },
      }),
      _c("div", { staticClass: "round-history-page__title" }, [
        _c("i", {
          staticClass: "round-history-page__icon icon icon_file-list-alt",
        }),
        _c("span", [_vm._v("对局")]),
        _c("span", { staticClass: "round-history-page__round-number" }, [
          _vm._v(" #" + _vm._s(_vm.gameData ? _vm.gameData.id : "") + " "),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "round-history-page__content" },
        [
          _c("wheel-game-color", {
            attrs: {
              color: _vm.wheelState.colorX2,
              multiplier: _vm.Multiplier.X2,
              "win-multiplier": _vm.gameData
                ? _vm.gameData.winColor
                : undefined,
              "is-loading": !_vm.gameData,
            },
          }),
          _c("wheel-game-color", {
            attrs: {
              color: _vm.wheelState.colorX3,
              multiplier: _vm.Multiplier.X3,
              "win-multiplier": _vm.gameData
                ? _vm.gameData.winColor
                : undefined,
              "is-loading": !_vm.gameData,
            },
          }),
          _c("wheel-game-color", {
            attrs: {
              color: _vm.wheelState.colorX4,
              multiplier: _vm.Multiplier.X4,
              "win-multiplier": _vm.gameData
                ? _vm.gameData.winColor
                : undefined,
              "is-loading": !_vm.gameData,
            },
          }),
          _c("wheel-game-color", {
            attrs: {
              color: _vm.wheelState.colorX35,
              multiplier: _vm.Multiplier.X35,
              "win-multiplier": _vm.gameData
                ? _vm.gameData.winColor
                : undefined,
              "is-loading": !_vm.gameData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }